import { ApiCallState } from "../Utils";
import { Material } from "../Material/Material.type";
import { Store } from "../Store/Store.type";

export const MaterialCountActionTypes = {
  FETCH_ALL_MATERIAL_COUNT: "FETCH_ALL_MATERIAL_COUNT",
  FETCH_ALL_MATERIAL_COUNT_SUCCESS: "FETCH_ALL_MATERIAL_COUNT_SUCCESS",
  FETCH_ALL_MATERIAL_COUNT_FAILURE: "FETCH_ALL_MATERIAL_COUNT_FAILURE",
  FETCH_ALL_MATERIAL_COUNT_RESET: "FETCH_ALL_MATERIAL_COUNT_RESET",

  BULK_UPSERT_MATERIAL_COUNT: "BULK_UPSERT_MATERIAL_COUNT",
  BULK_UPSERT_MATERIAL_COUNT_SUCCESS: "BULK_UPSERT_MATERIAL_COUNT_SUCCESS",
  BULK_UPSERT_MATERIAL_COUNT_FAILURE: "BULK_UPSERT_MATERIAL_COUNT_FAILURE",
  BULK_UPSERT_MATERIAL_COUNT_RESET: "BULK_UPSERT_MATERIAL_COUNT_RESET",
};

export type MaterialCount = {
  id?: number;
  user_id?: number;
  material_id: number;
  store_id: number;
  quantity: number | null;
  remark?: string;
  date: string;
  material?: Material;
  store?: Store;
  createdAt?: string;
  updatedAt?: string;
};

export type MaterialCountStateTypes = {
  fetchAll: ApiCallState<MaterialCount[]>;
  bulkUpsert: ApiCallState<any>;
};
